import { useState } from "react";
import { Plus } from "lucide-react";
import { FAQ } from "../data/site";
import { Reveal } from "./Reveal";

export const Faq = () => {
  const [open, setOpen] = useState(0);

  return (
    <div className="mx-auto max-w-3xl divide-y divide-[#8A9B87]/20 rounded-3xl border border-[#8A9B87]/20 bg-white px-6 sm:px-8" data-testid="faq-list">
      {FAQ.map((item, i) => {
        const isOpen = open === i;
        return (
          <Reveal key={item.q} delay={i * 0.05}>
            <div className="py-5 sm:py-6">
              <button
                type="button"
                onClick={() => setOpen(isOpen ? null : i)}
                aria-expanded={isOpen}
                data-testid={`faq-question-${i}`}
                className="flex w-full items-center justify-between gap-4 text-left"
              >
                <h3 className="text-base sm:text-lg font-medium text-[#2E2E2C]">{item.q}</h3>
                <span
                  className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#8A9B87]/15 text-[#8A9B87] transition-transform duration-300 ${
                    isOpen ? "rotate-45" : ""
                  }`}
                >
                  <Plus size={16} strokeWidth={1.8} />
                </span>
              </button>
              <div
                className={`grid transition-[grid-template-rows] duration-300 ease-out ${
                  isOpen ? "grid-rows-[1fr]" : "grid-rows-[0fr]"
                }`}
              >
                <div className="overflow-hidden">
                  <p className="pt-3 pr-10 text-base text-[#2E2E2C]/70 leading-relaxed" data-testid={`faq-answer-${i}`}>
                    {item.a}
                  </p>
                </div>
              </div>
            </div>
          </Reveal>
        );
      })}
    </div>
  );
};
